import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styles from "./statistic.module.css";
import StatisticFormat from "components/statisticFormat/statisticFormat";
import { statistic9 } from "services/statistic/statistic9";
import { generateCSVContent, downloadFile } from "utils/statistic";
import { Statistik9Data } from "modules/statistic";


export default function Statistic9() {
  const [data, setData] = useState<Statistik9Data[]>([]);

  const fetchData = async () => {
    try {
      const res = await statistic9();
      const { data } = res;
      setData(data);
    } catch (error) {
      console.error("Fehler beim Laden der Daten:", error);
    }
  };
  const downloadCSV = () => {
    const headers = ['Year', 'Total Bookings'];

    const rows: (string | number)[][] = data.map((entry) => [
      entry.year,
      entry.total_bookings,
    ]);

    const csvContent = generateCSVContent(headers, rows);
    downloadFile(csvContent, "Anlage5.csv");
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <StatisticFormat
      label=""
      description=''
      onButton1Click={downloadCSV}
    >
      <div className={styles.container}>

        <ResponsiveContainer width="100%" height={450} maxHeight={450}>
          <BarChart data={data} margin={{ top: 40, right: 30, left: 20, bottom: 5 }} style={{ maxHeight: "420px" }}>
            <text
              x="50%"
              y="20"
              textAnchor="middle"
              dominantBaseline="middle"
              style={{ fontSize: "16px", fontWeight: "bold" }}
            >
              Gesamtanzahl der Buchungen pro Jahr
            </text>

            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="year" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="total_bookings" fill="#0170c1" name="Buchungen" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </StatisticFormat>
  );
}
